import React, { Component } from 'react';
import {fromJS} from "immutable";
import {isInt} from 'validator';

// Components
import Select from "../../../components/common/virtualized-select";
import StatusSelector from "../../../components/common/StatusSelector";

class CustomerDetail extends Component {
    render() {
        const { mode, customer, paymentTypes, onChangeInput } = this.props;
        let formBody;
        let statusColor = '', statusText = '';

        switch (customer.status) {
            case 'active':
                statusColor = 'primary';
                statusText = 'Activo';
                break;
            case 'inactive':
                statusColor = 'danger';
                statusText = 'Inactivo';
                break;
            default:
                break;
        }

        switch (mode) {
            case 'view':
                formBody = (
                    <div>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Código de Cliente *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.customer_code}
                                        onChange={ (event) => onChangeInput('customer_code', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>NIF/CIF *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.basic_info_fiscal_id}
                                        onChange={ (event) => onChangeInput('basic_info_fiscal_id', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Cuenta Contable *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.account_code}
                                        onChange={ (event) => onChangeInput('account_code', event.target.value) }
                                    />
                                </div>
                            </div>
                            { customer && customer.status
                                ? <div className="col-3">
                                    <label>Estado</label>
                                    <div className="row">
                                        <div className="col-6">
                                            <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                        </div>
                                        <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                            <StatusSelector
                                                statusObject={fromJS(customer)}
                                                statusOptions={['active', 'inactive']}
                                                changeStatus={this.props.changeCustomerStatus}
                                            />
                                        </div>
                                    </div>
                                </div>
                                : null
                            }
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Nombre comercial *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.basic_info_name}
                                        onChange={ (event) => onChangeInput('basic_info_name', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Nombre fiscal *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.basic_info_fiscal_name}
                                        onChange={ (event) => onChangeInput('basic_info_fiscal_name', event.target.value) }
                                    />
                                </div>
                            </div>
                        </div>
                        <h4>Domicilio</h4>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Dirección *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.basic_info_address}
                                        onChange={ (event) => onChangeInput('basic_info_address', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>País *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_country}
                                        onChange={ (event) => onChangeInput('basic_info_country', event.target.value) }
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Provincia *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_province}
                                        onChange={ (event) => onChangeInput('basic_info_province', event.target.value) }
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Población *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_city}
                                        onChange={ (event) => onChangeInput('basic_info_city', event.target.value) }
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Código Postal *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.basic_info_postal_code}
                                        onChange={ (event) => onChangeInput('basic_info_postal_code', event.target.value) }
                                    />
                                </div>
                            </div>
                        </div>
                        <h4>Contacto</h4>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Email</label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        disabled={true}
                                        value={customer.basic_info_email}
                                        onChange={ (event) => onChangeInput('basic_info_email', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Teléfono</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.basic_info_phone}
                                        onChange={ (event) => onChangeInput('basic_info_phone', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Móvil</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.basic_info_mobile_phone}
                                        onChange={ (event) => onChangeInput('basic_info_mobile_phone', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Fax</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.basic_info_fax}
                                        onChange={ (event) => onChangeInput('basic_info_fax', event.target.value) }
                                    />
                                </div>
                            </div>
                        </div>
                        <h4>Persona de Contacto</h4>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Nombre *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.contact_person_name}
                                        onChange={ (event) => onChangeInput('contact_person_name', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Email</label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        disabled={true}
                                        value={customer.contact_person_email}
                                        onChange={ (event) => onChangeInput('contact_person_email', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Teléfono</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.contact_person_phone}
                                        onChange={ (event) => onChangeInput('contact_person_phone', event.target.value) }
                                    />
                                </div>
                            </div>
                        </div>
                        <h4>Datos bancarios</h4>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Forma de pago *</label>
                                    <Select
                                        className="virtualized-select"
                                        options={paymentTypes.toJS()}
                                        value={customer.payment_type}
                                        labelKey="type_name"
                                        valueKey="type_code"
                                        matchProp="type_name"
                                        multi={false}
                                        searchable={false}
                                        clearable={false}
                                        onChange={(valueSelected) => onChangeInput('payment_type', valueSelected.type_code)}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Banco *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.bank_info_name}
                                        onChange={ (event) => onChangeInput('bank_info_name', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>IBAN</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.bank_info_iban}
                                        onChange={ (event) => onChangeInput('bank_info_iban', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Swift</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.bank_info_swift}
                                        onChange={ (event) => onChangeInput('bank_info_swift', event.target.value) }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );
                break;
            case 'edit':
                formBody = (
                    <div>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Código de Cliente *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={true}
                                        value={customer.customer_code}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>NIF/CIF *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_fiscal_id}
                                        onChange={ (event) => onChangeInput('basic_info_fiscal_id', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Cuenta Contable *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.account_code}
                                        onChange={ (event) => {
                                            const account_code = event.target.value;
                                            if (isInt(account_code) || account_code === '') {
                                                onChangeInput('account_code', account_code);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <label>Estado</label>
                                <div className="row">
                                    <div className="col-6">
                                        <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Nombre comercial *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_name}
                                        onChange={ (event) => onChangeInput('basic_info_name', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Nombre fiscal *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_fiscal_name}
                                        onChange={ (event) => onChangeInput('basic_info_fiscal_name', event.target.value) }
                                    />
                                </div>
                            </div>
                        </div>
                        <h4>Domicilio</h4>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Dirección *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_address}
                                        onChange={ (event) => onChangeInput('basic_info_address', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>País *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_country}
                                        onChange={ (event) => onChangeInput('basic_info_country', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Provincia *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_province}
                                        onChange={ (event) => onChangeInput('basic_info_province', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Población *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_city}
                                        onChange={ (event) => onChangeInput('basic_info_city', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Código Postal *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_postal_code}
                                        onChange={ (event) => {
                                            const postal_code = event.target.value;
                                            if (isInt(postal_code) || postal_code === '') {
                                                onChangeInput('basic_info_postal_code', event.target.value);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <h4>Contacto</h4>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Email</label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        value={customer.basic_info_email}
                                        onChange={ (event) => onChangeInput('basic_info_email', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Teléfono</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_phone}
                                        onChange={ (event) => onChangeInput('basic_info_phone', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Móvil</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_mobile_phone}
                                        onChange={ (event) => onChangeInput('basic_info_mobile_phone', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Fax</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.basic_info_fax}
                                        onChange={ (event) => onChangeInput('basic_info_fax', event.target.value) }
                                    />
                                </div>
                            </div>
                        </div>
                        <h4>Persona de Contacto</h4>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Nombre *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.contact_person_name}
                                        onChange={ (event) => onChangeInput('contact_person_name', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Email</label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        value={customer.contact_person_email}
                                        onChange={ (event) => onChangeInput('contact_person_email', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Teléfono</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.contact_person_phone}
                                        onChange={ (event) => onChangeInput('contact_person_phone', event.target.value) }
                                    />
                                </div>
                            </div>
                        </div>
                        <h4>Datos bancarios</h4>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Forma de pago *</label>
                                    <Select
                                        className="virtualized-select"
                                        options={paymentTypes.toJS()}
                                        value={customer.payment_type}
                                        labelKey="type_name"
                                        valueKey="type_code"
                                        matchProp="type_name"
                                        multi={false}
                                        searchable={true}
                                        clearable={false}
                                        onChange={(valueSelected) => {
                                            if (valueSelected) {
                                                onChangeInput('payment_type', valueSelected.type_code);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Banco *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.bank_info_name}
                                        onChange={ (event) => onChangeInput('bank_info_name', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>IBAN</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.bank_info_iban}
                                        onChange={ (event) => onChangeInput('bank_info_iban', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Swift</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={customer.bank_info_swift}
                                        onChange={ (event) => onChangeInput('bank_info_swift', event.target.value) }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );
                break;
            default:
                formBody = null;
                break;
        }

        return formBody;
    }
}

export default CustomerDetail;



// WEBPACK FOOTER //
// ./src/containers/sales/customers/CustomerDetail.js